import { setCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';
import { Duration } from 'luxon';

export const COOKIE_LIFETIME_IN_DAYS_LONG = 360;

export const SHARED_COOKIE_LIFETIME = Duration.fromObject({ days: COOKIE_LIFETIME_IN_DAYS_LONG }).toMillis();
export const SHARED_COOKIE_DOMAIN = `.${process.env.SHARED_DOMAIN}`;

const SPLIT_SIZE = -2;

export const getSharedCookieOptions = (
  expires: Date = new Date(Date.now() + SHARED_COOKIE_LIFETIME),
  domain: string = SHARED_COOKIE_DOMAIN,
): OptionsType => {
  return { domain, expires, sameSite: 'none', secure: true };
};

export const getDefaultCookieDomain = (): string => {
  return window?.location?.hostname?.split('.')?.slice(SPLIT_SIZE)?.join('.');
};

export const setCookieWithSameSiteNoneSecure = (key: string, value: string, cookieOpts?: OptionsType) => {
  const cookieOptions: OptionsType = { ...cookieOpts, sameSite: 'none', secure: true };
  setCookie(key, value, cookieOptions);
};
